import React, { useEffect } from "react";
import _ from "lodash";
import { Col, Container, Row } from "reactstrap";
import pauseBtn from "../../../assets/images/bingo/pause.png";
import playBtn from "../../../assets/images/bingo/play.png";

import NextNumberModal from "./NextNumberModal";
import backArrow from "../../../assets/images/bingo/back-arrow.png";
import userImg from "../../../assets/images/bingo/user-img.png";
import crossIcon from "../../../assets/images/bingo/cross-icon.png";
import game_Paused_img from "../../../assets/images/bingo/Game_Paused_img.png";

const Playing = ({
  current_number,
  lastNumber,
  gamePaused,
  toggleGamePaused,
  showNumberModal,
  countdown,
  output_array,
  currentAlphabet,
  paramsReducerr,
  scoreTrack,
  volumeLevel,
  onTimesUp,
  timedGame,
}) => {
  const parameters = _.get(paramsReducerr, "3_playing");
  const parameters_preplay = _.get(paramsReducerr, "2_preplay");
  let customClass = "current-circle-red";
  // console.log(paramsReducerr?.background_music, "paramsReducerr?.gameObj?.background_music");
  function coustomClass(curr_number) {
    if (curr_number < 16) {
      customClass = "current-circle-red";
    } else if (curr_number >= 16 && curr_number <= 30) {
      customClass = "current-circle-blue";
    } else if (curr_number >= 31 && curr_number <= 45) {
      customClass = "current-circle-purple";
    } else if (curr_number >= 46 && curr_number <= 60) {
      customClass = "current-circle-orange";
    } else if (curr_number > 60) {
      customClass = "current-circle-green";
    } else {
      customClass = "current-circle-none";
    }
    return customClass;
  }

  const playTrack = (attr) => {
    const callAudio = document.getElementById("playAudioTrack");
    if (callAudio) {
      callAudio
        .play()
        .then(() => {})
        .catch(() => {});
    }
  };
  useEffect(() => {
    playTrack("playBuzzTrack");
    const callAudio = document.getElementById("playAudioTrack");
    callAudio.volume = volumeLevel;
  }, [volumeLevel]);

  return (
    <>
      <audio loop id="playAudioTrack" src={paramsReducerr?.background_music}></audio>
      <div className="bingo-preplay-wrapper bingo-playing-screen">
        <Container>
          <Row>
            <Col xs={12} sm={12} lg={12} xl={12}>
              <div className="bingo-preplay-content">
                <div className="bingo-preplay-numbers-container">
                  <div className="bingo-logo">
                    <p className="red">B</p>
                    <p className="blue">I</p>
                    <p className="purple">N</p>
                    <p className="orange">G</p>
                    <p className="green">O</p>
                  </div>
                  <div className="bingo-preplay-numbers">
                    <div className="bingo-preplay-number">
                      {output_array.map((item, index) => {
                        return (
                          <span
                            className={`${
                              index < 15
                                ? item.highlight
                                  ? "red-filled-number-circle"
                                  : "red-circle"
                                : index < 30
                                ? item.highlight
                                  ? "blue-filled-number-circle"
                                  : "blue-circle"
                                : index < 45
                                ? item.highlight
                                  ? "purple-filled-number-circle"
                                  : "purple-circle"
                                : index < 60
                                ? item.highlight
                                  ? "orange-filled-number-circle"
                                  : "orange-circle"
                                : item.highlight
                                ? "green-filled-number-circle"
                                : "green-circle"
                            }`}
                          >
                            {item.num}
                          </span>
                        );
                      })}
                    </div>
                    {timedGame && gamePaused && (
                      <div className="bingo-game-paused">
                        <audio id="playScoreTrack" src={scoreTrack}></audio>
                        <h2>game paused</h2>
                      </div>
                    )}
                  </div>
                </div>
                <div className="bingo-playing-status">
                  {timedGame ? (
                    <div className="play-btn-wrapper">
                      <p className="play-text">
                        {" "}
                        {!gamePaused ? parameters?.next_label : parameters_preplay?.resume_label} <br />{" "}
                        <span className="count">{countdown}</span>
                      </p>
                      <button onClick={toggleGamePaused} className="play-btn">
                        {gamePaused ? <img src={playBtn} alt="" /> : <img src={pauseBtn} alt="" />}
                      </button>
                    </div>
                  ) : (
                    <button onClick={onTimesUp} type="button" className="next-ball-btn">
                      next <br />
                      ball
                    </button>
                  )}
                  <div className="current">
                    <p className="current-text">{parameters?.current_label}</p>
                    <div className={coustomClass(current_number)}>
                      <p className="alpha">{currentAlphabet(current_number)}</p>
                      <p className="num">{current_number}</p>
                    </div>
                  </div>
                  <div className="last">
                    <p className="last-text">{parameters?.last_label}</p>
                    <div className={coustomClass(lastNumber) + "-last"}>
                      <p className="alpha">{currentAlphabet(lastNumber)}</p>
                      <p className="num">{lastNumber}</p>
                    </div>
                  </div>
                </div>
              </div>
              {showNumberModal && (
                <NextNumberModal
                  currentAlphabet={currentAlphabet}
                  paramsReducerr={paramsReducerr}
                  current_number={current_number}
                  coustomClass={coustomClass}
                />
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
export default Playing;
